export default __webpack_public_path__ + "static/media/group-599@2x.419829dc.png";